import { useMemo } from "react";

import { AnyEntity } from "@mapmycustomers/shared/types/entity";

const useFilteredEntities = (search: string, ...lists: AnyEntity[][]) =>
  useMemo(() => {
    const searchValue = search.toLowerCase().trim();
    if (searchValue.length) {
      return lists.map((list) =>
        list.filter((entity) =>
          "name" in entity ? entity.name.toLowerCase().trim().includes(searchValue) : false
        )
      );
    }
    return lists;
  }, [search, lists]);

export default useFilteredEntities;
